module.exports = __webpack_public_path__ + "img/quikr-easy.2c0cfa27.png";